<template>
    <div class="button-toggle">
        <div class="toggle" @click="toggle" v-bind:class="{ on : isOn }">
            <span class="material-icons" v-if="isOn">toggle_on</span>
            <span class="material-icons" v-if="!isOn">toggle_off</span>
        </div>
        <div class="hide"><input type="checkbox" v-model="isOn" v-bind:name="name" /></div>
    </div>

</template>

<script>
    module.exports = {
        created:function() {
            this.isOn = this.on;
        },
        data:function() {
            return {
                isOn:false
            }
        },
        props: {
            on:{type:Boolean,default:false},
            name:{type:String,default:'toggle'},
            container:{type:String,default:''}
        },
        methods: {
            toggle:function() {
                this.isOn = this.isOn ? false : true;
                this.checkContainer();
            },
            checkContainer() {
                if(this.container != ''){
                    if(this.isOn) {
                        $(this.container).show();
                    }  else {
                        $(this.container).hide();
                    }
                }
            }
        },
        mounted:function() {
            this.checkContainer();
        }
    }
</script>
